import { render, staticRenderFns } from "./doubleColumnCharts.vue?vue&type=template&id=584053db&scoped=true"
import script from "./doubleColumnCharts.vue?vue&type=script&lang=js"
export * from "./doubleColumnCharts.vue?vue&type=script&lang=js"
import style0 from "./doubleColumnCharts.vue?vue&type=style&index=0&id=584053db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584053db",
  null
  
)

export default component.exports